"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nextInstance = exports.initializeI18n = void 0;
const sdk_common_1 = require("@sisense/sdk-common");
const index_js_1 = require("./resources/index.js");
function initializeI18n() {
    return (0, sdk_common_1.initI18next)({
        resource: index_js_1.resources,
        language: 'en',
        namespace: index_js_1.PACKAGE_NAMESPACE,
    });
}
exports.initializeI18n = initializeI18n;
exports.i18nextInstance = initializeI18n().i18nextInstance;
